import { get, post } from '../client'
import type { CandidateActivation } from '../types/generated'

export async function getActivation(): Promise<CandidateActivation> {
  return get<CandidateActivation>('api/candidate/activation')
}

export async function manualUnlock(): Promise<CandidateActivation> {
  return post<CandidateActivation>('api/candidate/activation/manual-unlock', {})
}

export async function dismissAction(actionId: string): Promise<void> {
  await post('api/candidate/activation/dismiss', { action_id: actionId })
}
